export const GOOGLE_ANALYTICS_ID = "UA-80001823-5";
export const APPLE_APP_ID = "1432534261";
